import React from 'react';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange,
  itemsPerPage = 10,
  totalItems
}) => {
  // Function to generate pagination numbers with dots
  const getPageNumbers = () => {
    const pageNumbers = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      pageNumbers.push(1);
      
      if (currentPage > 3) {
        pageNumbers.push('...');
      }
      
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(currentPage + 1, totalPages - 1); i++) {
        pageNumbers.push(i);
      }
      
      if (currentPage < totalPages - 2) {
        pageNumbers.push('...');
      }
      
      pageNumbers.push(totalPages);
    }
    return pageNumbers;
  };

  // Calculate start and end items
  const startItem = Math.min((currentPage - 1) * itemsPerPage + 1, totalItems);
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div className="flex flex-col items-center justify-between px-4 py-3 sm:flex-row sm:items-center">

      {/* Pagination Buttons */}
      <div className="flex w-full justify-center items-center space-x-2">
        
        {/* Previous Button */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`flex items-center justify-center w-10 h-10 rounded-full transition-all duration-300 
            ${currentPage === 1 
              ? 'bg-gray-200 text-gray-400 cursor-not-allowed' 
              : 'bg-white text-gray-700 shadow-md hover:bg-orange-500 hover:text-white'}`}
        >
          ❮
        </button>

        {/* Page Numbers */}
        {getPageNumbers().map((page, index) => (
          <button
            key={index}
            onClick={() => typeof page === 'number' ? onPageChange(page) : null}
            disabled={typeof page !== 'number'}
            className={`w-10 h-10 aspect-square rounded-full transition-all duration-300 font-semibold flex items-center justify-center 
              ${typeof page !== 'number' 
                ? 'cursor-default text-gray-500'
                : currentPage === page
                  ? 'bg-[#F16745] text-white shadow-lg scale-110'
                  : 'bg-white text-gray-700 shadow-md hover:bg-[#F16745] hover:text-white'}`}
          >
            {page}
          </button>
        ))}

        {/* Next Button */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`flex items-center justify-center w-10 h-10 rounded-full transition-all duration-300 
            ${currentPage === totalPages 
              ? 'bg-gray-200 text-gray-400 cursor-not-allowed' 
              : 'bg-white text-gray-700 shadow-md hover:bg-[#F16745] hover:text-white'}`}
        >
          ❯

        </button>
      </div>
    </div>
  );
};

export default Pagination;
